import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger'; 
import setupSlideshow from './components/slideshow';
import objectFitImages from 'object-fit-images';
import { overlayMenu, loader, gridHeight, flexDirection, setupVerticalList } from './functions';
import { animateElements } from './animations';

gsap.registerPlugin(ScrollTrigger);

window.onload = () => {
  const coverImages = document.querySelectorAll('.cover-image');
  objectFitImages(coverImages);
  setupSlideshow('#slideshow .slides');
  setupSlideshow('.page__gallery .slides');
  overlayMenu();
  loader();
  setupVerticalList();
  //gridHeight();
  // flexDirection();
  // animateElements();

  if ($('body').hasClass('single-art_on_demand')) {
    if (document.referrer.indexOf("galimberti")) {
      $('a.back-link').attr('src', 'javascript:history.go(-1)')
      console.log('back js')
    }
  }
  
};

